import { Options } from '../options.interface';
import { EMAIL_API_CONFIG } from './email-api.config';
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Email, EmailSearch } from '@wizbii/utils/models';
import { Observable } from 'rxjs';

@Injectable()
export class EmailWebservice {
  readonly #http = inject(HttpClient);
  readonly #emailApiConfig = inject(EMAIL_API_CONFIG);

  readonly #baseUrl = this.#emailApiConfig.baseUrl;

  /**
   * Get user received email list
   * @param {Object} [options] Angular Options for the request
   */
  getEmails(options?: Options): Observable<EmailSearch> {
    return this.#http.get<EmailSearch>(`${this.#baseUrl}/v1/email`, options);
  }

  /**
   * Get an email details
   * @param emailId Email identifier
   * @param {Object} [options] Angular Options for the request
   */
  getEmailById(emailId: string, options?: Options): Observable<Email> {
    return this.#http.get<Email>(`${this.#baseUrl}/v1/email/${emailId}`, options);
  }
}
